import React from "react";
import PropTypes from "prop-types";

PageTitle.propTypes = {
    title: PropTypes.string
};

function PageTitle({title }) {
    return (
        <h1 className="type-24">{title}</h1>
    );
}

export default PageTitle;